import { Source } from "react-map-gl"
import { shadingPolygons } from "../../appState/shadingSignals"
import Layer from "react-map-gl/dist/esm/components/layer"
import { seasonMonth } from "../../appState/simulationSignals"

const seasonShade = (month: number) => {
    if (month > 3 && month < 7) return 0.13
    if (month == 12 || month <= 3) return 0.05
    return 0.2
}

const TreeShadeSource: React.FC = () => {
    return <>
        <Source id="tree-shades" type="geojson" data={shadingPolygons.value} generateId>
            <Layer
                id="tree-shades"
                source="tree-shades"
                type="fill"
                paint={{
                    'fill-color': '#000',
                    'fill-opacity': seasonShade(seasonMonth.value),
                }}
            />
        </Source>
    </>
}

export default TreeShadeSource